import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, Select, SelectItem } from '@nextui-org/react';
import { toast } from 'react-toastify';
import { useDocumentUpload } from '../../../hooks/useDocumentUpload';
import { FilePreview } from '../../../components/documents/file-preview';
import { PreviewTable } from '../../../components/tables/preview-table';
import { ShipmentsUpload } from '../../../components/shipments-upload';
import { MovementsUpload } from '../../../components/movements-upload';
import { PageLayout, SectionTitle } from '../../../components/ui';

const SuperadminShipments = () => {
  const [documentType, setDocumentType] = useState<string>('');
  const {
    file,
    setFile,
    previewData,
    columns,
    isUploading,
    handleFileRead,
    handleUpload,
    handleCancel,
  } = useDocumentUpload();

  const handleDocumentTypeChange = (value: string) => {
    setDocumentType(value);
    handleCancel();
  };

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      if (!documentType) {
        toast.warning('Por favor selecciona un tipo de documento primero');
        return;
      }
      const file = acceptedFiles[0];
      setFile(file);
      await handleFileRead(file, documentType);
    },
    [documentType]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        '.xlsx',
      ],
      'application/vnd.ms-excel': ['.xls'],
    },
    maxFiles: 1,
  });

  const handleUploadClick = async () => {
    if (!documentType) {
      toast.warning('Por favor selecciona un tipo de documento');
      return;
    }
    const success = await handleUpload(documentType);
    if (success) {
      handleCancel();
    }
  };

  return (
    <PageLayout className='flex flex-col gap-8'>
      {/* Pre-settlements Section */}
      <section>
        <SectionTitle title='Despachos' />
        <ShipmentsUpload />
      </section>
      <section>
        <SectionTitle title='Anticipos' />
        <MovementsUpload />
      </section>

      
    </PageLayout>
  );
};

export default SuperadminShipments;
